import { __decorate, __metadata } from "tslib";
import { IsDateTimeGreaterThanOrEqual } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsISO8601, IsInstance, IsOptional, ValidateNested } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
import { ReadItemSetSpeciaLDayScheduleDto } from './ReadItemSetSpeciaLDayScheduleDto';
export class ReadItemSetMetadataCriteriaSpecialDayDto {
}
__decorate([
    ApiProperty({ type: () => ReadItemSetSpeciaLDayScheduleDto, isArray: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadItemSetSpeciaLDayScheduleDto),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    IsInstance(ReadItemSetSpeciaLDayScheduleDto, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadItemSetMetadataCriteriaSpecialDayDto.prototype, "schedule", void 0);
__decorate([
    ApiProperty({ type: () => Date, example: '2009-02-29' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsISO8601({}, { always: true }),
    __metadata("design:type", Object)
], ReadItemSetMetadataCriteriaSpecialDayDto.prototype, "from", void 0);
__decorate([
    ApiProperty({ type: () => Date, example: '2009-02-29' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsISO8601({}, { always: true }),
    IsDateTimeGreaterThanOrEqual('from', { format: 'yyyy-MM-dd' }, { always: true }),
    __metadata("design:type", Object)
], ReadItemSetMetadataCriteriaSpecialDayDto.prototype, "to", void 0);
//# sourceMappingURL=ReadItemSetMetadataCriteriaSpecialDayDto.js.map